import { Group, Paper, Pill, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { t } from 'i18next';

import { TitleCard } from '@/core/components';

import { LanguagePill } from '@feature/utils';

import { Journal } from './../../model/JournalTypes';
import classes from './JournalCard.module.css';

export interface JournalCardProps {
  journal: Journal;
  to: string;
}

export function JournalCard({ journal, to }: JournalCardProps) {
  const { title, publisher, issn, language, bdis, isUmfstOwned, wosId } = journal;

  return (
    <Paper
      className={classes.card}
      component={Link}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="12px">
        <TitleCard
          title={title}
          pre={
            isUmfstOwned ? (
              <Pill
                bg="blue"
                c="white"
              >
                {t('journals.view.umfst')}
              </Pill>
            ) : (
              wosId && (
                <Pill
                  bg="green"
                  c="white"
                >
                  {t('journals.view.ISIindexed')}
                </Pill>
              )
            )
          }
        />
        <Group>
          <LanguagePill language={language} />
          <Text
            c="dimmed"
            size="sm"
          >
            {publisher?.title}
          </Text>
        </Group>
        <Group>
          {(issn ?? []).map(i => (
            <Pill key={i.id}>{i.code}</Pill>
          ))}
        </Group>
        {bdis.length > 0 && (
          <Group>
            {(bdis ?? []).map(i => (
              <Pill key={i.id}>{i.name}</Pill>
            ))}
          </Group>
        )}
      </Stack>
    </Paper>
  );
}
